import { toReadableTimestamp } from '../../utils/orderUtils';

export default function GiftDetails({ order, testMode }) {
    if (!order) return null;

    return (
        <div className="table-container">
            <table className="table">
                <tbody>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Gift Order ID:
                        </td>
                        <td style={{ 
                            fontFamily: 'var(--font-family-mono)', 
                            fontWeight: 'var(--font-weight-medium)',
                            color: 'var(--text-secondary)'
                        }}>
                            <a href={`${testMode ? '/test' : ''}/orders/gift/${order.gift_purchase.gift_order_id}`} style={{ color: 'var(--link-color)' }}>
                                {order.gift_purchase.gift_order_id}
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Gift Code:
                        </td>
                        <td style={{ color: 'var(--text-secondary)' }}>
                            {order.gift_purchase.code}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Gift Code Stripe ID
                        </td>
                        <td style={{ color: 'var(--text-secondary)' }}>
                            {order.gift_purchase.promotion_code_id}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Recipient Name:
                        </td>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)'
                        }}>
                            {order.gift_purchase.sender_name}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Recipient Email:
                        </td>
                        <td style={{ color: 'var(--text-secondary)' }}>
                            {order.gift_purchase.recipient_email}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)',
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Personal Message:
                        </td>
                        <td style={{ color: 'var(--text-secondary)' }}>
                            {order.gift_purchase.personal_message || '—'}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

           